import React from 'react'
import Layout from '../components/Layout'

const Index = () => (
  <Layout>
    <h1>Home</h1>
    <p>
      <a href="https://html-perf.vercel.app">HTML version</a>
    </p>
  </Layout>
)

export default Index
